export const noop = () => {/* noop*/};

export const sleep = (ms: number) => new Promise(res => {
    window.setTimeout(res, ms);
});
